module.exports = __webpack_public_path__ + "static/media/Logo.892aac64.png";